import { useSelector } from 'react-redux';

import { selectSelectedSite } from '../../store/selectors/userInfo';
import { removeSpacesBetweenHyphen } from '../utils';
import { useSelectIsStore } from '../../apis/startup/startup.selectors';

export const useDataStudio = () => {
  const {
    id: storeId,
    name,
    address: { countryCode },
  } = useSelector(selectSelectedSite);
  const isRW = !useSelectIsStore();

  const regionNamesInEnglish = new Intl.DisplayNames(['en'], {
    type: 'region',
  });

  const countryName = regionNamesInEnglish.of(countryCode);
  const storeNameWithoutSpaces = removeSpacesBetweenHyphen(name);

  const baseUrl = 'https://prod-uk-a.online.tableau.com/#/site/dktunited/views/';
  const pageName = isRW ? 'Workshop-PageRW_17369552227240/RWHomepage' : 'Workshop-HomePage_17283911461640/Homepage';

  const url = `${baseUrl}${pageName}?:iid=${storeId}&country_name=${countryName}&site=${storeNameWithoutSpaces}`;

  return encodeURI(url);
};
